// extracted by mini-css-extract-plugin
export default {"buttonClose":"ButtonClose_buttonClose__0OyQj","buttonClose__frame":"ButtonClose_buttonClose__frame__NQ0uv"};